// Footer.js
import React from 'react';
import csirt from '../styles/img/csirt.png';
import ciras from '../styles/img/ciras.png';
import enisa from '../styles/img/ENISA.png';

const Footer = () => {
  return (
    <footer>
        <div className="container">
          <div>
            <section className="logos">
               <div className="home-content">
                   <a target="_blank" href="https://csirtsnetwork.eu/"><img src={csirt} alt="CSIRT Network" /></a>
               </div>
               <div className="home-content">
                    <a target="_blank" href="https://www.enisa.europa.eu/topics/vulnerability-disclosure"><img src={enisa} alt="ENISA CVD" /></a>
               </div>
               <div className="home-content">
                   <a target="_blank" href="https://ciras.enisa.europa.eu/"><img src={ciras} alt="CIRAS" /></a>
               </div>
            </section>
            <section className="links small-container">
              <a  href='/about' target='self'>About</a>
              <a className="" href='/faq' target='_self'>FAQ</a>
              <a className="margin-bottom" href='/apidoc' target='_self'>API</a>

              <a href='https://enisa.europa.eu/about-enisa/legal-notice/legal-notice' target='_blank'>Legal Notice</a>
              <a href='https://enisa.europa.eu/about-enisa/data-protection/data-protection' target='_blank'>Data Protection</a>
              <a href='https://enisa.europa.eu/about-enisa/contact/contact' target='_blank'>Contact</a>
            </section>
          </div>
          <div className='texts'>
            <div>
              <p>© 2025 by the European Union Agency for Cybersecurity.</p>
            </div>
            <div className='small-container'>
              <p>ENISA is an agency of the European Union</p>
            </div>
          </div>
        </div>
    </footer>
  );
};

export default Footer;
